// import packages or dependencies
import {
  Box,
  Button,
  Container,
  Grow,
  SvgIcon,
  Typography,
  useTheme,
} from "@mui/material";
import { memo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus-icon.svg";
import ResponsiveCreateUser from "./responsive-create-user/ResponsiveCreateUser";
import CreateUserForm from "./create-user-form/CreateUserForm";
import {
  openCreateaUserFormAction,
  userManagement,
} from "../userManagementSlice";

/**
 * @returns This component returns the CreateUserForm form container 
 */
function CreateUser() {
  // states and handlers
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const {
    createUser: { formIsOpen },
  } = useAppSelector(userManagement);

  // render jsx
  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          p: { xs: 0 },
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        }}
        data-testid="container"
      >
        <Typography
          sx={{
            fontSize: "24px",
            color: (theme) => theme.palette.text.secondary,
            mb: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              mb: "6px",
            },
          }}
          data-testid="user_management_title"
        >
          User Management
        </Typography>

        <Box>
          <Button
            id="ignoreDisableTouch"
            variant="contained"
            color="tertiary"
            fullWidth
            type="submit"
            sx={{
              width: "170px",
              height: "45px",
              fontSize: "18px",
              borderRadius: "5px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
              [theme.breakpoints.down("md")]: {
                width: "155px",
                height: "38px",
                fontSize: "16px",
              },
              [theme.breakpoints.down(680)]: {
                width: "calc(50% - 4px)",
              },
              "&.Mui-disabled": {
                color: "black",
              },
            }}
            onClick={(event) => {
              dispatch(
                openCreateaUserFormAction({
                  type: "create",
                  formIsOpen: !formIsOpen,
                })
              );
            }}
            disabled={formIsOpen}
            data-testid="create_user_button"
          >
            <SvgIcon
              component={PlusIcon}
              inheritViewBox
              sx={{
                width: "16px",
                height: "16px",
                color: "inherit",
                stroke: (theme) => theme.palette.tertiary?.contrastText,
                cursor: "pointer",
                mr: "4px",
                [theme.breakpoints.down("md")]: {
                  height: "16px",
                },
              }}
              data-testid="create_user_svg_icon"
            />
            Create User
          </Button>
        </Box>
      </Container>

      <Grow
        style={{ transformOrigin: "0 0 0" }}
        {...(formIsOpen ? { timeout: 500 } : {})}
        in={formIsOpen}
        data-testid="create_user_form"
      >
        <Box>{formIsOpen ? <CreateUserForm /> : null}</Box>
      </Grow>

      <ResponsiveCreateUser />
    </>
  );
}

export default memo(CreateUser);
